import React from 'react';
import { reportClientError } from '../utils/bugReporter';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportClientError(error, {
      source: 'react.error_boundary',
      componentStack: errorInfo?.componentStack || null
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-loading">
          Something went wrong. Reload the page and try again.
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
